module.exports = __webpack_public_path__ + "img/bayern-munchen-logo-icon.ae67d2c5.png";